import script from "./documents-list-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./documents-list-item.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__